import { advanceEngagement, cancelEngagement, } from '@/entities/engagement';
export async function advanceEngagementAction(engagementId, note) {
    return advanceEngagement(engagementId, note);
}
export async function cancelEngagementAction(engagementId, reason) {
    await cancelEngagement(engagementId, reason);
}
